import alt from '../alt';
import checkPtsAction from '../actions/checkPtsAction';

class checkPtsStore {
    constructor() {
        this.bindActions(checkPtsAction);
        this.processing = false;
        //this.radius = 0;
        this.checkPoint = [];
        this.removedCheckPoint = [];
        this.IP = [];
        this.removedIP = [];
    }

    onProcessing(data) {
        this.processing = data;
    }
    onClear(data) {
        this.checkPoint = [];
        this.removedCheckPoint = [];
        //this.radius = 0;
    }

    onCheckPoint(data) {
        this.checkPoint = data;
    }
    onRemovedCheckPoint(data) {
        this.removedCheckPoint = data;
    }

    onRadius(data) {
        this.radius = data;
    }
    onIp(data) {
        this.IP = data;
    }
    onRemovedIP(data) {
        this.removedIP = data;
    }
}
export default alt.createStore(checkPtsStore, 'checkPtsStore');


// WEBPACK FOOTER //
// ./app/stores/checkPtsStore.js